<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">P<span class="smallcaps">ART </span>1<span class="smallcaps"> <br/></span>M<span class="smallcaps">OM’S </span>G<span class="smallcaps">ONE </span>M<span class="smallcaps">ISSING</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ghost-town_00003.vue?6b83041a